export default {
    REVIEW_CARD_MARGIN: 56
};
